// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3U8K1","col":"styles_col__QUMlI"};